import capitalize from './capitalize';

const getValidQueryFilterItems = (
  queryParam: string | readonly string[] | undefined,
  filterItems: readonly string[]
) => {
  if (typeof queryParam === 'undefined') {
    return;
  }

  if (Array.isArray(queryParam)) {
    return queryParam
      .filter((queryItem) => filterItems.includes(capitalize(queryItem)))
      .map(capitalize);
  }

  if (typeof queryParam === 'string') {
    const queryItem = capitalize(queryParam);
    return filterItems.includes(queryItem) ? [queryItem] : [];
  }
};

export default getValidQueryFilterItems;
